module.exports = __webpack_public_path__ + "img/buddy_mouth-04.4cf2cf67.svg";